import * as service from './service'
export default {
  namespace: 'recommendMessengerRuleDetails',
  state: {
    demoData: {}
  },
  effects: {
  },
  reducers: {
    save (state, { payload }) {
      return { ...state, ...payload }
    }
  }
}
